/**
 * Skeleton — §7.18 (mission 6 WP03 T020; FR-005, NFR-007).
 *
 * navy-100 shimmering to navy-50 over 1.4s, off under reduced motion, hidden
 * from assistive technology. The caller sizes it and matches the radius of the
 * element it replaces. Tables show five skeleton rows (`TableSkeletonRows`).
 */
import * as React from 'react'

import { cn } from './cn'

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      data-skeleton=""
      className={cn(
        'animate-[trellis-shimmer_1.4s_ease-in-out_infinite] rounded-md bg-navy-100 motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  )
}
